import Link from 'next/link';
import React from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Button from '@/components/@base/button';
import Card, { CardContent, CardMedia } from '@/components/@base/card';
import { Text } from '@/components/@base/typography';
import Props from '@/components/app/product/components/bundle-comments/bundle-comment-card/type';

import ICON_SIZE from '@/constant/icon-size-color';
import { pageLevelLocalization } from '@/constant/localization';
const { product: productLocalization } = pageLevelLocalization;

export default function QuestionCard({ icon, title, slug }: Props) {
  return (
    <Card className='flex-row items-center justify-start bg-white p-2 md:p-4' noShadow>
      <Link href={`/web/${slug}`} className='ml-3 min-w-[80px] md:ml-4' prefetch={false}>
        <CardMedia
          src={icon?.publicLink}
          width={80}
          height={80}
          alt={icon?.title}
          className='h-[80px] w-[80px] rounded-lg'
        />
      </Link>

      <CardContent center className='w-full flex-col justify-between gap-2 p-0! md:flex-row'>
        <Text
          size={SIZE_ENUM.SM}
          bold
          className='line-clamp-1 text-[#5B5C60] hover:text-[#ff9606]'
        >
          <Link href={`/web/${slug}`} prefetch={false}>
            {title}
          </Link>
        </Text>

        <a
          href={`/web/${slug}/comments`}
          target='_blank'
          rel='noopener noreferrer'
          className='self-end'
        >
          <Button
            Icon={<HiOutlineExternalLink size={ICON_SIZE.sm} />}
            className='text-sm hover:bg-[#EB8800]'
          >
            {productLocalization.openProductQuestions}
          </Button>
        </a>
      </CardContent>
    </Card>
  );
}
